import React from "react"
import { useTranslation } from "gatsby-plugin-react-i18next"

import LightBulb from "@images/lightbulb.svg"
import TwoColumnIconTextCombo from "@modules/TwoColumns/TwoColumnIconTextCombo"

const InefficientManagement = () => {
  const { t } = useTranslation()

  const params = {
    theme: "lBlue",
    col1content: {
      icon: LightBulb,
      label: t("SubheaderTag_Challenge"),
      title: t("CaseStudyCompetitive_Subheader2"),
      arrtext: [
        t("CaseStudyCompetitive_Paragraph3"),
      ],
      img: null,
    },
    col2content: {
      icon: "",
      label: "",
      title: "",
      arrtext: [],
      img: "higher_standard.png",
      classes: { img: "h-[320px] md:h-auto" },
    },
    col1class: "",
    col2class: "",
    containerClass: "",
    reverse: true,
    backgroundImage: null,
  }
  return <TwoColumnIconTextCombo {...params} />
}

export default InefficientManagement
